export default "__VITE_ASSET__CVw5_yw8__"